import { all } from 'redux-saga/effects';

import AuthSagas from "./Auth/saga";
import UserSagas from "./User/saga";
import LookupsSagas from "./Lookups/saga";
import RewardsSagas from "./Rewards/saga";
import TripsSagas from "./Trips/saga";
import VerificationRequestsSagas from "./VerificationRequests/saga";
import AdminsSagas from "./Admins/saga";
import ReferralsSagas from "./Referrals/saga";
import OffersSagas from "./Offers/saga";
import AnimationsSagas from "./Animations/saga";
import ServicesSagas from "./Services/saga";
import AgentChatSagas from "./AgentChat/saga";
import ChallengesSagas from "./Challenges/saga";

export default function* rootSaga() {
  yield all([
    AuthSagas(),
    UserSagas(),
    LookupsSagas(),
    RewardsSagas(),
    TripsSagas(),
    VerificationRequestsSagas(),
    AdminsSagas(),
    ReferralsSagas(),
    OffersSagas(),
    AnimationsSagas(),
    ServicesSagas(),
    AgentChatSagas(),
    ChallengesSagas(),
  ]);
}
